import { type LinkType } from '../data/sanity/queries/types/content'

export type UrlParameters = Record<string, string>

export type Slugs = string | string[] | null

export type PageType = LinkType

const pageRoutes: Record<PageType, string[]> = {
  blogAuthor: ['blog', 'author', '[author_slug]'],
  blogCategory: ['blog', 'category', '[category_slug]'],
  blogPage: ['blog'],
  blogPost: ['blog', '[post_slug]'],
  cartPage: ['cart'],
  collection: ['shop', '[collection_slug]'],
  homePage: [],
  page: ['[page_slug]'],
  product: ['products', '[product_slug]'],
  shopPage: ['shop'],
  work: ['work', '[work_slug]'],
  workPage: ['work'],
}

const getUrlSegments = (
  pageType: PageType,
  slugs: string | string[] | null = null
) => {
  const urlSlugs = slugs && Array.isArray(slugs) ? slugs : [slugs]
  let slugIndex = 0

  return (
    pageRoutes[pageType]?.map((segment) => {
      // Replace segment placeholder with a slug or an empty string
      if (/\[.*\]/.test(segment)) {
        slugIndex += 1
        return urlSlugs?.[slugIndex - 1] ?? ''
      }

      return segment
    }) ?? []
  )
}

const getUrlParameterString = (parameters?: Record<string, string>) => {
  const searchParams = new URLSearchParams()

  Object.entries(parameters ?? {}).forEach((parameter) => {
    if (parameter[0] && parameter[1]) {
      searchParams.set(parameter[0], parameter[1])
    }
  })

  return searchParams.toString()
}

/**
 * Gets relative page URL for Next.js links without locale segment.
 */
export const getLinkPageUrl = (
  pageType: PageType,
  slugs?: Slugs,
  parameters?: UrlParameters
) => {
  const pageUrlSegments = getUrlSegments(pageType, slugs)
  const url = pageUrlSegments.filter(Boolean).join('/')

  const urlParameters = getUrlParameterString(parameters)
  const urlWithParameters = [url, urlParameters].filter(Boolean).join('?')

  return `/${urlWithParameters}`
}
